import { useTranslation } from 'react-i18next';

import { Body1, Heading2 } from '@myphx-engineering/phx-design-system';
import { IllustrationCard, NoClaimsIllustration } from '@phx/myphx-lib';

export const NoHistory = () => {
    const { t } = useTranslation();

    return (
        <IllustrationCard
            Illustration={NoClaimsIllustration}
            variant="bare"
            illustrationPosition="top"
            withShadow={false}
            illustrationSize="lg"
            header={<Heading2>{t('cabinet.history.empty.heading')}</Heading2>}
        >
            <Body1>{t('cabinet.history.empty.body')}</Body1>
        </IllustrationCard>
    );
};
